import React from 'react';
import FeatureFlagContext from './FeatureFlagContext'

class FeatureFlag extends React.Component {
  render () {
    const name = this.props.name;
    const children = this.props.children; 
    const defaultChildren =  this.props.defaultChildren
    return (
      <FeatureFlagContext.Consumer>
        {features => {
          if (features && (features[name] || features[name] === undefined)) {
            return children
          }
          return defaultChildren
        }}
      </FeatureFlagContext.Consumer>
    )
  }
}

FeatureFlag.defaultProps = {
  defaultChildren: null
}

export default FeatureFlag